import React, { useEffect, useState } from 'react';
import './css/LoadingSpinner.scss'; 

const LoadingSpinner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Small delay to ensure the fade-in animation works
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 10);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`loader-container ${isVisible ? 'visible' : ''}`}>
      <div className="loader"></div>
    </div>
  );
}

export default LoadingSpinner;
